<template>
  <div class="rules">
    <p class="title">一、	等级介绍</p>
    <p>企鹅汇图等级体系设有Lv0迷途书童等级、Lv1探路先锋等级、Lv2巡城高手等级、Lv3无疆行者等级、Lv4鸿图画师等级5个等级，企鹅汇图为不同等级用户提供差异化的特权与福利（详情见等级体系页面）。</p>
    <p class="title">二、	经验值介绍</p>
    <p>
      1、	经验值是企鹅汇图用户等级成长进度值，经验值越高，能达到的等级越高，享受的权益也越丰富。<br /><br />
      2、	经验值自首次获得时开始累计并开始计时，计时3个自然月为一个周期。<br />
      （1）	计时一个周期内，累计达到下一等级经验值要求，则等级晋升，所有经验值清零，重新开始一个周期的经验值累计与计时；<br />
      （2）	计时一个周期到期时，判断该周期累计获得经验值是否符合当前等级经验值要求，符合则维持当前等级，不符合则下降一个等级（如当前等级为Lv1，则维持等级不再降级），该周期内获得的经验值清零，重新开始下一个周期的经验值累计与计时；<br /><br />
      <i style="font-size: 14px;color: #333;">（举例：<br />
      （1）	用户A于1月1日获得第1个经验值，则从此刻开始累计经验值并开始计时，用户A于1月15日累计达到30经验值，则等级晋升为Lv2，同时重新开始累计经验值和一个周期的计时；<br />
      （2）	如上述用户在1月15日—3月16日这一个计时周期内，获得经验值大于等于30且小于600（大于600则继续晋升等级），则在周期结束时，清零本周起所有经验值，保持Lv2等级进入下一个周期；如获得经验值小于30，不能达到Lv2要求，则清零本周起所有经验值，降为Lv1等级进入下一个周期。）</i><br /><br />
      3、每个周期每位用户最高可获得9999经验值，超出后该周期内不再获得经验值；<br /><br />
      4、经验值对应等级标准<br /><br />
      <table cellspacing="0" cellpadding="0"
        style="border:0.75pt solid #000000; -aw-border:0.5pt single; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
        <tr>
            <td
                style="width:100.95pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; background-color:#b6dde8; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:11pt"><span
                        style="font-family:微软雅黑; font-weight:bold">等级</span></p>
            </td>
            <td
                style="width:81.3pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; background-color:#b6dde8; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:11pt"><span
                        style="font-family:微软雅黑; font-weight:bold">经验值标准</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:100.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">Lv0</span></p>
            </td>
            <td
                style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">注册即得</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:100.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">Lv1</span></p>
            </td>
            <td
                style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">1</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:100.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">Lv2</span></p>
            </td>
            <td
                style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">30</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:100.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">Lv3</span></p>
            </td>
            <td
                style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">600</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:100.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">Lv4</span></p>
            </td>
            <td
                style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                        style="font-family:微软雅黑">2000</span></p>
            </td>
        </tr>
    </table>
    </p>
    <p class="title">三、	经验值的获取</p>
    <p>完成企鹅汇图上的任务且任务通过审核，可获得对应经验值（详细如下表），更多经验值获取方式敬请期待。-等级体系中的任务权益</p>
    <table cellspacing="0" cellpadding="0"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:93.85pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; background-color:#b6dde8; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:11pt"><span
                            style="font-family:微软雅黑; font-weight:bold">完成任务类型</span></p>
                </td>
                <td
                    style="width:237.25pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; background-color:#b6dde8; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:11pt"><span
                            style="font-family:微软雅黑; font-weight:bold">获取经验值</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:93.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">道路任务</span></p>
                </td>
                <td
                    style="width:237.25pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">根据任务等级不同可获得5、10、15、30经验值</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:93.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">地点任务</span></p>
                </td>
                <td
                    style="width:237.25pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">根据地点任务类型不同可获得1、2、5经验值</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:93.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">公交任务</span></p>
                </td>
                <td
                    style="width:237.25pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">可获得2经验值</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:93.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">室内任务</span></p>
                </td>
                <td
                    style="width:237.25pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">可获得5经验值</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:93.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">招募任务</span></p>
                </td>
                <td
                    style="width:237.25pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single">
                    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:10.5pt"><span
                            style="font-family:微软雅黑">可获得5经验值</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-top:0pt; margin-bottom:0pt"><span style="font-family:微软雅黑">*任务通过审核后，经验值才会得到累加。</span></p>
  </div>
</template>
<script>
import { defineComponent, onMounted, getCurrentInstance } from 'vue';

export default defineComponent({
  setup(){
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    onMounted(() => {
      beacon.onUserAction('level_rules_show')
    })
  }
})
</script>

<style lang="scss" scoped>
.rules {
  background: #fff;
  min-height: 100%;
  padding: 10px 15px;
  box-sizing: content-box;
  .title {
    font-size: 18px;
    margin-top: 36px;
  }
  p {
    box-sizing: content-box;
    padding: 10px;
    font-size: 14px;
    // line-height: 20px;
  }
}
</style>
